import {Popover} from '@material-ui/core'
import {KeyboardArrowRight as KeyboardArrowRightIcon} from '@material-ui/icons'
import React, {useState, useContext, useMemo} from 'react'
import GroupingIcon from '../../../../common/Icons/GroupingIcon'
import './SortingModal.scss'
import GroupBy from './GroupBy'
import {ReservationContext} from '../../../../context/Reservation'
import useReservationGanttContext from '../../../../context/ReservationGantt/ReservationGantt'
import _ from 'lodash'

const SortingModal = ({open = false, anchorEl = null, onClose = () => {}}) => {
  const [showGroups, setShowGroups] = useState(false)
  const {entityFields} = useContext(ReservationContext)
  const {setGroupBy, groupBy} = useReservationGanttContext()
  const a = []
  a.sort()

  const options = useMemo(() => {
    const fields = entityFields.filter(f => f.field_type === 'EntityListField')
    return _.sortBy(fields, ['field_name'])
  }, [entityFields])

  const handleClose = e => {
    setShowGroups(false)
    onClose(e)
  }

  const handleChangeGroupBy = (e, b) => {
    setGroupBy(b)
    setShowGroups(false)
    onClose(e)
  }

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      disableScrollLock={true}
      classes={{paper: 'm-sorting-modal c-sorting-modal c-res-mod'}}
      style
    >
      <div className="res-mod c-sorting-modal__item" onClick={() => setShowGroups(p => !p)}>
        <GroupingIcon />
        <span style={{flex: 1, marginLeft: 8}}>Group By</span>
        <KeyboardArrowRightIcon />
      </div>
      <GroupBy show={showGroups} options={options} onChange={handleChangeGroupBy} value={groupBy} />
    </Popover>
  )
}

export default SortingModal
